import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { BootstrapSemanticVariation } from '@app/utils/bootstrap';

@Component({
  selector: 'portal-save-button',
  templateUrl: './save-button.component.html',
  styleUrls: ['./save-button.component.scss'],
  standalone: false,
})
export class SaveButtonComponent implements OnChanges, OnInit {
  @ViewChild('button')
  button: ElementRef<HTMLButtonElement>;

  @Input() buttonType: 'button' | 'submit' = 'submit';
  @Input() defaultSpinner: boolean = true;
  @Input() disabledOnPristine: boolean = true;
  @Input() disabledTooltip?: string;
  @Input() invalid?: boolean;
  @Input('disabled') isDisabled: boolean = false;
  @Input() noTooltips: boolean = false;
  @Input() size: string = 'md';
  @Input() state: boolean;
  @Input() pristine?: boolean;
  @Input() variant: BootstrapSemanticVariation = 'primary';

  @Output() save: EventEmitter<void> = new EventEmitter();

  buttonClass: string;

  get disabled() {
    let disabled;

    if (this.isDisabled) {
      disabled = true;
    } else {
      if (this.disabledOnPristine) {
        if (this.pristine) {
          disabled = true;
        } else {
          disabled = this.invalid;
        }
      } else {
        disabled = this.invalid;
      }
    }

    return disabled;
  }

  get tooltip() {
    let tooltip = '';

    if (this.disabledTooltip != null) {
      tooltip = this.disabledTooltip;
    } else if (this.pristine) {
      tooltip = 'general.form.tooltip.pristine';
    } else if (this.invalid) {
      tooltip = 'general.form.tooltip.invalid';
    }

    return tooltip;
  }

  get tooltipEnabled() {
    let enabled = false;

    if (this.noTooltips === false && this.disabledOnPristine) {
      const isPristine = this.pristine === true;
      const isInvalid = this.invalid === true;
      const isDisabledWithTooltip = this.disabled === true && this.disabledTooltip != null;

      enabled = isPristine || isInvalid || isDisabledWithTooltip;
    }

    return enabled;
  }

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if ('variant' in changes || 'size' in changes) {
      this.updateButtonClass(
        changes.variant?.currentValue ?? this.variant,
        changes.size?.currentValue ?? this.size
      );
    }
  }

  ngOnInit() {
    this.noTooltips = this.noTooltips !== false;

    this.updateButtonClass(this.variant, this.size);
  }

  click() {
    this.save.emit();
  }

  focus(): void {
    this.button?.nativeElement?.focus();
    this.button?.nativeElement?.classList.add('visible-focus');
  }

  private updateButtonClass(variant: BootstrapSemanticVariation, size: string): void {
    this.buttonClass = `btn btn-${variant} btn-${size}`;
  }
}
